module.exports = __webpack_public_path__ + "static/media/ucas_official.2fc1b578.png";